<template>
  <div class="my-4">

    <!-- service options dropdown-->

    <div ref="panOptions">
      <Multiselect :close-on-select="true" :canClear="false" :canDeselect="false" :options="options" label="name" valueProp="id" v-model="selectedOptionId" class="z-[31]" @open="showOverlay(panOptions)" @close="hideOverlay">
        <template v-slot:singlelabel="{ value }">
          <div class="multiselect-single-label">
            <div class="lg:flex lg:gap-2 lg:items-center">{{ value.name }}<strong class="block lg:inline">{{ value.price ? '+' : '' }} {{ locale.formatPrice(value.price, true) }}{{ serviceDeliveryText(value.delivery) }}</strong></div>
          </div>
        </template>
        <template v-slot:option="{ option }">
          <div class="lg:flex lg:gap-2 lg:items-center">{{ option.name }}<strong class="block lg:inline">{{ option.price ? '+' : '' }} {{ locale.formatPrice(option.price, true) }}{{ serviceDeliveryText(option.delivery) }}</strong></div>
        </template>
      </Multiselect>
    </div>

    <!-- "t" configuration -->

    <div v-if="selectedOption.configuration.includes('t')">

      <OrganismsPanelsServiceConfigurationBlock
        :selectedOption="selectedOption"
        :max-rows="props.maxRows"
        :max-characters-per-row="props.maxCharactersPerRow"
        :label="selectedOption.labels && selectedOption.labels.textLabel1 ? selectedOption.labels.textLabel1 : null"
        @service-changed="c => {tConfig = c; serviceUpdated();}"
        ></OrganismsPanelsServiceConfigurationBlock>

      <!-- "u" configuration -->

      <div v-if="selectedOption.configuration.includes('u')">
        <OrganismsPanelsServiceConfigurationBlock
          :selectedOption="selectedOption"
          :max-rows="props.maxRows"
          :max-characters-per-row="props.maxCharactersPerRow"
          :label="selectedOption.labels && selectedOption.labels.textLabel2 ? selectedOption.labels.textLabel2 : null"
          @service-changed="c => {uConfig = c; serviceUpdated();}"
          ></OrganismsPanelsServiceConfigurationBlock>
      </div>

      <!-- warning -->

      <strong class="block mt-6 mb-4 text-warning">
        <AtomsImagesIcon icon="inf" /> {{ $t('Upozornění') }}
      </strong>
      {{ $t('Rytina bude zhotovena přesně tak, jak si sami navrhnete! Prosíme, vpisujte přesné znění textu, který si přejete vyrýt. Rozlišujte malá a velká písmena a diakritiku.') }}
    </div>
    <AtomsGlobalOverlay :isVisible="isOverlayVisible" />
  </div>
</template>
<script setup>

import { useBreakpoints } from '@vueuse/core';
import Multiselect from '@vueform/multiselect';
import "assets/css/multiselect.css";

const props = defineProps({
  service: Object,
  maxRows: Number,
  maxCharactersPerRow: Number
});


const locale = useLocale();
const utils = useUtils();
const appConfig = useAppConfig();
const view = useBreakpoints(appConfig.breakpoints);

const panOptions = ref(null);

const isOverlayVisible = ref(false);

const tConfig = ref(null);
const uConfig = ref(null);

const showOverlay = (scrollRef) => {
  if (view.smaller('desktop').value) {
    scrollTo(scrollRef.getBoundingClientRect().top + window.scrollY - 10, () => {
      isOverlayVisible.value = true;
      utils.setBodyScrollable(false);
    });
  }
}

const scrollTo = (top, onScrolledCallback) => {
  window.scrollTo({ top: top, behavior: 'smooth' });

  if (typeof onScrolledCallback === 'function') {
    setTimeout(() => onScrolledCallback(), 250);
  }
}

const hideOverlay = () => {
  if (view.smaller('desktop').value) {
    isOverlayVisible.value = false;
    utils.setBodyScrollable(true);
  }
}

function parseWeirdJson(str) {
  if (str == null) return null;
  let fixed = str.replace(/([{,\s])(\w+)\s*:/g, '$1"$2":');
  fixed = fixed.replace(/'/g, '"');
  return JSON.parse(fixed);
}

const options = props.service.options.map(option => {
  return {
    id: option.id,
    price: option.price,
    delivery: option.delivery,
    configuration: option.configuration,
    name: `${utils.capitalize(props.service.name)} - ${option.name}`,
    labels: option.labels ? parseWeirdJson(option.labels) : null
  };
}).sort((a, b) => a.price - b.price);


const selectedOptionId = ref(options[0].id);
const selectedOption = computed(() => options.find(q => q.id === selectedOptionId.value));

watch(selectedOptionId, () => {
  serviceUpdated();
});

const serviceUpdated = () => {

  let serviceConfiguration = null;

  if (selectedOption.value.configuration.includes('t')) {
    if (selectedOptionId.value && tConfig.value) {
      serviceConfiguration = {
        soId: selectedOptionId.value,
        f: tConfig.value.f,
        t: tConfig.value.t,
        c: '0$' + tConfig.value.c
      };
      if (selectedOption.value.configuration.includes('u')) {
        if (uConfig.value) {
          serviceConfiguration.f += ', ' + uConfig.value.f;
          serviceConfiguration.t += ', ' + uConfig.value.t;
          serviceConfiguration.c += '$' + uConfig.value.c;
        }
      }
    }
  }
  else {
    serviceConfiguration = {
      soId: selectedOptionId.value
    }
  }
  emit('serviceSelected', serviceConfiguration);
};

const serviceDeliveryText = (inTxt) => {
            var days = parseInt(inTxt);
            if (!isNaN(days) && days > 0) {
                if (days == 1) return " (+1 den výroba)";
                else if (days <= 4) return " (+" + inTxt + " dny výroba)";
                else return " (+" + inTxt + " dní výroba)";
            }
            else {
                return "";
            }
        };

const emit = defineEmits(['serviceSelected']);

</script>